export default "__VITE_ASSET__CSM57KNn__"